import { Box, Button, darken, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { TP_COLORS } from '../../../../constants';
import { getUrlConvertedString, isMobileScreen } from '../../../../helper';
import { ITopic } from '../../../../store/TopicSlice';

interface IExploreTopicsBarProps {
  topicData: ITopic;
}

const ExploreTopicsBar: React.FC<IExploreTopicsBarProps> = ({ topicData }) => {
  const navigate = useNavigate();
  const isMobile = isMobileScreen();

  return (
    <Box
      sx={{
        height: { xs: '84px', sm: '80px' },
        display: 'flex',
        alignItems: 'center',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: { xs: 'space-evenly', sm: 'center' },
        position: 'sticky',
        borderRadius: '10px',
        zIndex: 5,
        mt: '30px',
        background: {
          xs: `url('${process.env.PUBLIC_URL}/images/backgrounds/explore-topics-left.png') top left/cover no-repeat, #1E293B`,
          sm: `url('${process.env.PUBLIC_URL}/images/backgrounds/explore-topics-left.png') top left/contain no-repeat, url('${process.env.PUBLIC_URL}/images/backgrounds/explore-topics-right.png') top right/contain no-repeat, #1E293B`,
        },
      }}
    >
      <Typography variant="subtitle1" color={TP_COLORS.white}>
        Ready to start your learning journey ?
      </Typography>
      <Button
        size={isMobile ? 'small' : 'medium'}
        color="secondary"
        variant="contained"
        onClick={() =>
          navigate(
            `${process.env.PUBLIC_URL}/dashboard/${getUrlConvertedString(
              topicData.curriculum
            )}/${getUrlConvertedString(
              topicData.subject
            )}/${getUrlConvertedString(
              topicData.subjectLevel
            )}/${getUrlConvertedString(topicData.subjectCode)}`
          )
        }
        sx={{
          minWidth: 'fit-content',
          width: isMobile ? '110px' : '135px',
          backgroundColor: '#3498DB',
          ml: '12px',
          '&:hover': {
            backgroundColor: darken('#3498DB', 0.3),
          },
        }}
      >
        Explore Topics
      </Button>
    </Box>
  );
};

export default ExploreTopicsBar;
